/**
 *                        * new point
 *                   .     -
 *              .           -
 *         .  angle          -
 *    *........................*
 *  center                    point
 *
 * Rotates the point `point` by angle `angle` with rotation point `center`.
 * @param point point to rotate
 * @param center rotation point
 * @param angle angle in degree
 */
export function rotate(point, center, angle) {
    var radians = degToRad(angle);
    var cos = Math.cos(radians);
    var sin = Math.sin(radians);
    var nx = cos * (point.x - center.x) + sin * (point.y - center.y) + center.x;
    var ny = cos * (point.y - center.y) - sin * (point.x - center.x) + center.y;
    return { x: nx, y: ny };
}
/**
 * Converts degree to radians.
 * @param deg angle in degree
 */
export function degToRad(deg) {
    return (Math.PI / 180) * deg;
}
/**
 * Converts radians to degree.
 * @param deg angle in radians
 */
export function radToDeg(rad) {
    return (180 / Math.PI) * rad;
}
//# sourceMappingURL=math-utils.js.map